import { isRef } from "vue";
import type { Ref } from "vue";

/**
 * @function get - get the value of a ref or the value itself if its not a ref
 * @param {Ref<ValueType> | ValueType} targetRef - possible ref to obtain the value
 */
export default function get<ValueType>(
  targetRef: Ref<ValueType> | ValueType
): ValueType {
  const value = isRef(targetRef) ? targetRef.value : targetRef;
  return value;
}
